import { setPropertySchema } from "../../utils/helpers";
import { Buttons } from "./buttons";

export class Textarea extends Buttons {
  dressTextAreas = () => {
    // get all dropdowns
    const textareas = this.form.querySelectorAll("textarea");

    // for each dropdown dress with data attributes
    textareas.forEach((textarea) => {
      const blocked = this.isBlocked(textarea);

      // get input properties
      const name = this.getName(textarea);
      const type = textarea.getAttribute("type");
      const value = textarea.value;

      // set properties on element
      textarea.setAttribute("data-fs-element", "textarea");
      name &&
        textarea.setAttribute("data-fs-textarea-name", name.toLowerCase());
      type && textarea.setAttribute("data-fs-textarea-type", type);
      if (value) {
        textarea.setAttribute(
          "data-fs-textarea-value",
          !blocked ? value : "blocked"
        );
        !blocked && this.updateButton(name ? name : "textarea", value);
      }

      if (!blocked) {
        // add event listener to update the dom with data values
        textarea.addEventListener("input", () => {
          // add input value property
          textarea.setAttribute("data-fs-textarea-value", textarea.value);

          // add value to button
          this.updateButton(name ? name : "textarea", textarea.value);

          // update property schema
          setPropertySchema(textarea);
        });
      }

      // set the property schema
      setPropertySchema(textarea);
    });
  };
}
